





















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IPromotionUpsellModel } from "../../models";

@Component
export default class UpsellPreviewModal extends Vue {
    @Prop({ required: true })
    model?: IPromotionUpsellModel;

    @Prop({ required: true, type: Boolean })
    value!: boolean;

    get localValue(): boolean {
        return this.value;
    }
    set localValue(value: boolean) {
        this.$emit("input", value);
    }

    closeModal() {
        this.localValue = false;
    }
}
